<template>
  <confirmation-dialog
    :disabled="loading"
    :loading="loading"
    small
    message-title="EXCLUIR?"
    message-body="Deseja realmente excluir o histórico?"
    open-class="btn-delete"
    open-left-icon="fa-trash"
    open-text="EXCLUIR"
    @yes="deleteHistory"
  />
</template>

<script>
import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "DeleteHistory",
  components: { ConfirmationDialog },
  props: {
    _id: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async deleteHistory() {
      try {
        this.loading = true;

        let deleteAll = this.$route.query.delete;

        let data = { _id: this._id, deleteAll };

        let response = await api.delete("/rest-home/stock/history", { data });
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
